import R from 'ramda'

const INITIAL_TWEET_TRIGGER_TYPE = 'INITIAL_TWEET'
const RETWEET_TRIGGER_TYPE = 'RETWEET_OF'
const LIKE_TRIGGER_TYPE = 'LIKE_OF'
const LIKE_OR_RETWEET_TRIGGER_TYPE = 'LIKE_OR_RETWEET'
const RETWEET_DISPLAY_TYPE = 'Retweet of a Tweet'
const LIKE_DISPLAY_TYPE = 'Like'
const LIKE_OR_RETWEET_DISPLAY_TYPE = 'Like OR Retweet'
const NEW_TWEET_ACTION = 'NEW_TWEET'

const isInitialTweetWidgetTrigger = R.propEq('type', INITIAL_TWEET_TRIGGER_TYPE)

const getType = R.cond([
  [R.propEq('result', RETWEET_TRIGGER_TYPE), R.always(RETWEET_DISPLAY_TYPE)],
  [R.propEq('result', LIKE_TRIGGER_TYPE), R.always(LIKE_DISPLAY_TYPE)],
  [
    R.propEq('result', LIKE_OR_RETWEET_TRIGGER_TYPE),
    R.always(LIKE_OR_RETWEET_DISPLAY_TYPE)
  ]
])

const convertInitialTweetWidgetTriggerToFormTrigger = R.applySpec({
  type: getType,
  action: R.always(NEW_TWEET_ACTION),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  value: R.prop('data'),
  isPromotedTweet: R.prop('isPromotedTweet')
})

export {
  isInitialTweetWidgetTrigger,
  convertInitialTweetWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/initial-tweet.js